import React from 'react'
import ReactDOM from 'react-dom'
import MainComponent from './components/MainComponent'
import { Router, hashHistory } from 'react-router';
import { Provider } from 'react-redux';
import getStore from './store'

  const store = getStore();

  const rootEl = document.createElement('div');
  document.body.appendChild(rootEl);

  const routes = {
    path: '/',
    component: MainComponent,
    childRoutes: [
        { path: '/:urlString', component: MainComponent },
        { path: '/source/:source', component: MainComponent }
    ]
};

  const Root = ({ store }) => (
    <Provider store={store}>
      <Router history={hashHistory} routes={routes}></Router>
    </Provider>
  );

  const render = () => ReactDOM.render(
    <Root store={store} />,
    rootEl
  )

  render()
  store.subscribe(render)




/** WEBPACK FOOTER **
 ** ./src/index.js
 **/